
(() => {
  const stylesheetSelector = 'link[data-lp-deferred-css]';
  const registeredStylesheets = new WeakSet();

  function initDeferredStylesheets(root) {
    const stylesheets = root.querySelectorAll(stylesheetSelector);

    stylesheets.forEach((stylesheet) => {
      if (stylesheet.media === 'all') return;

      if (stylesheet.sheet) {
        stylesheet.media = 'all';
        return;
      }

      if (registeredStylesheets.has(stylesheet)) return;

      registeredStylesheets.add(stylesheet);

      stylesheet.addEventListener(
        'load',
        () => {
          stylesheet.media = 'all';
        },
        { once: true }
      );
    });
  }

  function init() {
    initDeferredStylesheets(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDeferredStylesheets(event.target);
  });
})();
